<template>
  <el-dialog
    :title="form.id ? $t('text.edit_role') : $t('text.add_role')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="730px"
    class="add-role"
  >
    <el-form
      label-width="120px"
      :model="form"
      :rules="rules"
      ref="form"
      v-loading="loading"
    >
      <el-form-item :label="$t('text.role_name')" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.role_permissions')">
        <el-table
          :data="permissionList"
          :span-method="objectSpanMethod"
          size="mini"
          border
        >
          <el-table-column :label="$t('text.level_1_module')">
            <template slot-scope="scope">
              {{ scope.row.parentNode }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.level_2_module')">
            <template slot-scope="scope">
              {{ scope.row.currentNode }}
            </template>
          </el-table-column>
          <el-table-column
            width="250px"
            :label="$t('text.permissions')"
            class-name="permission-column"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-for="(permission, i) in scope.row.permissions"
                :key="i"
                v-model="permission.isActive"
                >{{ permission.name }}</el-checkbox
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        :loading="saveLoading"
        @click="submit()"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        name: '',
        modules: []
      },
      rules: this.initRules(),
      permissionList: [],
      loading: false,
      saveLoading: false
    }
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.rules = this.initRules()
    }
  },
  methods: {
    initRules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('text.name_required'),
            trigger: 'blur'
          }
        ]
      }
    },
    openDialog() {
      this.dialogVisible = true
      this.getRoleDetail()
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    closeDialog() {
      this.form = {
        id: '',
        name: '',
        modules: []
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    objectSpanMethod(e) {
      if (e.columnIndex === 0) {
        if (e.row.count) {
          return {
            rowspan: e.row.count,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getRoleDetail() {
      this.permissionList = []
      this.loading = true
      let id = this.form.id || 0
      ApiService.GetRolePermission(id)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            let vm = this
            this.form = response.data.data
            response.data.data.modules.forEach(item => {
              item.childModules.forEach((subItem, key) => {
                let obj = {
                  parentNode: item.name,
                  parentId: item.id,
                  currentNode: subItem.name,
                  currentId: subItem.id,
                  permissions: subItem.permissions
                }
                if (key === 0) {
                  obj.count = item.childModules.length
                }
                vm.permissionList.push(obj)
              })
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Failed'
          })
        })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let checkedPermissions = []
          this.form.modules.forEach(item => {
            item.childModules.forEach(childItem => {
              childItem.permissions.forEach(permission => {
                if (permission.isActive) {
                  checkedPermissions.push(permission)
                }
              })
            })
          })
          if (!checkedPermissions.length) {
            swal({
              icon: 'warning',
              timer: 2000,
              title: 'Please set permissions'
            })
            return
          }
          this.save()
        }
      })
    },
    save() {
      this.saveLoading = true
      let params = {
        Id: this.form.id,
        Name: this.form.name,
        Modules: this.form.modules
      }
      ApiService.SaveRolePermission(this.form.id, params)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.closeDialog()
            this.$parent.getRoleList()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Failed'
          })
        })
    }
  }
}
</script>
